// src/components/useApi.js — hook pour appels API avec gestion d'erreurs
import { useState, useCallback } from "react";

/**
 * useApi() — wrapper autour des appels API avec états loading/error.
 *
 * Usage :
 *   const { loading, error, run } = useApi();
 *   const data = await run(() => API.get("/exams/"));
 */
export function useApi() {
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);

  const run = useCallback(async (fn) => {
    setLoading(true);
    setError(null);
    try {
      const result = await fn();
      return result;
    } catch (e) {
      // FastAPI peut retourner detail comme string OU liste d'objets de validation
      const raw = e?.response?.data?.detail;
      let msg;
      if (!raw) {
        msg = e?.message || "Erreur de connexion au serveur.";
      } else if (typeof raw === "string") {
        msg = raw;
      } else if (Array.isArray(raw)) {
        // Erreurs de validation Pydantic : [{loc, msg, type, ...}]
        msg = raw.map(e => e?.msg || JSON.stringify(e)).join(" — ");
      } else {
        msg = "Erreur serveur.";
      }
      setError(msg);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearError = useCallback(() => setError(null), []);

  return { loading, error, run, clearError };
}